<template>
  <section>
    <VisualAdmin :admin="admin" :idEmpresa="idEmpresa" />
    <br />
    <b-row>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Sin cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 5x6</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('A')" class="fa fa-file-pdf-o fa-3x mt-2" exact></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Con Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 5x7</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('B')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Sin Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 7x10</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('C')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Con Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 7x12</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('D')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Sin Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 18x12</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('E')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Con Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 18x12</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('F')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Sin Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 21x18</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('G')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" md="6">
        <b-card style="color:black;" header="Con Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 22x18</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('H')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!--  HALLIBURTON!!    -->
    <!-- <b-row v-if="admin">
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Halliburton" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>Halliburton10.8X4.65</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('I')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Halliburton" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>Halliburton14X10.5</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('J')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Halliburton" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>Halliburton21.5x14</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('K')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3"></b-col>
    </b-row> -->
    <!--   FIN HALLIBURTON!!!    -->

    <!--  BAKER!!    -->
    <!-- <b-row v-if="admin">
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Baker" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>Baker11x7.5</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('L')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Baker" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>Baker29x21</h5>
              <span class="span">
                <i>(Editable se imprime 1)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('M')" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3"></b-col>
      <b-col sm="6" lg="3"></b-col>
    </b-row> -->
    <!--   FIN BAKER!!!    -->

    <b-row v-if="admin">
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Sin Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 5x6</h5>
              <span class="span">
                <i>(Editable se imprime 3,6,9)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('A', cantidad1)" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
          <br>
          <b-row >
            <b-col lg="6">
              <b-form-select v-model="cantidad1" :options="opt369"/>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Con Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 5x7</h5>
              <span class="span">
                <i>(Editable se imprime 3,6,9)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('B', cantidad2)" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
          <br>
          <b-row >
            <b-col lg="6">
              <b-form-select v-model="cantidad2" :options="opt369"/>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Sin Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 7x10</h5>
              <span class="span">
                <i>(Editable se imprime 2,4)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('C', cantidad3)" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
          <br>
          <b-row >
            <b-col lg="6">
              <b-form-select v-model="cantidad3" :options="opt24"/>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card style="color:black;" header="Con Cabecera" align="center" class="contenedor">
          <b-row>
            <b-col lg="8">
              <h5>SGA 7x12</h5>
              <span class="span">
                <i>(Editable se imprime 2,4)</i>
              </span>
            </b-col>
            <b-col lg="3" md="12" sm="12">
              <i @click.stop="generarEtiquetas('D', cantidad4)" class="fa fa-file-pdf-o fa-3x mt-2"></i>
            </b-col>
          </b-row>
          <br>
          <b-row >
            <b-col lg="6">
              <b-form-select v-model="cantidad4" :options="opt24"/>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </section>
</template>

<script>
import VisualAdmin from "./VisualAdmin";

import { mapActions, mapState } from 'vuex';

export default {
  name: "productos-etiquetas",
  props:['admin','idEmpresa'],
  components: {
    VisualAdmin
  },
  data() {
    return {
      opt369: [3, 6, 9],
      opt24: [2, 4],
      cantidad1: 3,
      cantidad2: 3,
      cantidad3: 2,
      cantidad4: 2
    };
  },
  computed: {
    ...mapState('etiquetas_et', [
      'pdfet',
      'VisualEmpresa'
    ]),
    ...mapState('sga_et',[
        'filtro'
    ]),
    ...mapState('productos_et',[
            'accion',
            'id_empresa',
            'ordenes',
            'empresas',
            'filtroEt',
            'selectedProductEt'
        ])
  },
  methods: {
    ...mapActions('etiquetas_et',[
      'generarEtiqueta'
    ]),

    async generarEtiquetas( tipo, cantidad = 0) {
      if( this.filtroEt.empresa != '' ){
        this.pdfet.empresa = this.filtroEt.empresa;
      }else{
        this.pdfet.empresa = this.idEmpresa;
      }

      this.pdfet.idioma = this.selectedProductEt.idioma
      this.pdfet.version = 6
      this.pdfet.regla = this.VisualEmpresa.regla
      this.pdfet.fabfecha = this.VisualEmpresa.fecha_fab
      this.pdfet.rol = 1
      this.pdfet.tipoproducto = 'productoEt'
      this.pdfet.cabecera = 0
      this.pdfet.tipoEtiqueta = tipo
      this.pdfet.cantidad = cantidad

      await this.generarEtiqueta()
    },
  }
};
</script>
